import SignaturePageContainer from './SignaturePageContainer';

export default SignaturePageContainer;



// WEBPACK FOOTER //
// ./src/components/pages/SelfCheckIn/SignaturePage/index.js